import { render } from "./ChooseTriggerType.vue?vue&type=template&id=fcb41d80&scoped=true"
import script from "./ChooseTriggerType.vue?vue&type=script&lang=ts"
export * from "./ChooseTriggerType.vue?vue&type=script&lang=ts"

import "./ChooseTriggerType.vue?vue&type=style&index=0&id=fcb41d80&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fcb41d80"

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QSpace,QIcon});
